import { ListBaseController } from "../components/fx";
import * as rolesService from "../services/RolesService";

const pageConfig: any = {
    pageTitle: 'Roles',
    sections: [
        {
            type: "filter",
            layout: 4,
            controls: [
                { label: 'Role Name', model: 'roleName', type: 'text' },
            ]
        },
        {
            type: "listview",
            listViewConfig: {
                canShowHeader: true,
                pagerConfig: {
                    pageSize: 25
                },
                sorterConfig: {
                    sortable: true,
                    sortInfo: {
                        name: "created_at",
                        direction: "desc"
                    }
                },
                mode: 'normal',
                fieldDefs: [
                    { field: 'roleCode', title: 'Role Code', type: 'label', size: 3, sort: true },
                    { field: 'roleName', title: 'Role Name', type: 'label', size: 3, sort: true },
                    { field: 'precedence', title: 'Precedence', type: 'label', size: 3, sort: true },
                    { field: 'actions', title: 'Actions', type: 'label', size: 3 }
                ],
                actions: [
                    { name: 'rolecontrolmap' },
                    { name: 'edit', displayText: 'Edit' },
                    { name: 'delete', displayText: 'Delete', placeholder: 'roleName' },
                ]
            }
        }

    ],
    actionBar: {
        controls: [
            { name: "add" }
        ]
    }
}

const listBaseController = ListBaseController({
    pageConfig: pageConfig,
    actions: {
        getItems: rolesService.getRoles,
        deleteItem: rolesService.deleteRole,
    }
}
);

export const useRoleListStore = listBaseController.getStore();